import { Service } from './../../../view/services/services.component';
import { Component, DoCheck, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';

import { OwlOptions } from 'ngx-owl-carousel-o';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
import { LoginService } from './login.service';
import { LoginRes } from './login';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'app/core/modal/role';
import { Location } from '@angular/common';
import { SharedService } from 'app/shared/services/shared.service';
import { IconsService } from 'app/shared/services/Modal/icons.service';
import { ServicesService } from 'app/pages/services/services.service';
@Component({
  selector: 'app-login2',
  templateUrl: './login2.component.html',
  styleUrls: ['./login2.component.scss']
})
/**
 * Login-2 component
 */
export class Login2Component implements OnInit {

  loginForm: FormGroup;
  submitted = false;
  error = '';
  returnUrl: string;
  messageError: any = '';
  // set the currenr year
  year: number = new Date().getFullYear();
  hide: boolean = false;
  lang: string = "ar"

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private _LoginService: LoginService,
    private toastrService: ToastrService,
    private authenticationService: AuthenticationService,
    private _SharedService: SharedService,
    private ServicesService: ServicesService,
    public icons: IconsService
  ) {
      this.lang = 'en';
    //   if (JSON.parse(localStorage.getItem("lang_ERP")))
    //   this.lang = JSON.parse(localStorage.getItem("lang_ERP")).lang
    // else{
    //   this.lang = 'en';
    //   localStorage.setItem("lang_ERP",JSON.stringify({"lang":"en"}))
    //   this.lang = JSON.parse(localStorage.getItem("lang_ERP")).lang
    //   location.reload()
    // }
  }

  ngOnInit(): void {
    // document.body.classList.add('auth-body-bg')
    this.loginForm = this.formBuilder.group({
      userNameOrEmail: [null, [Validators.required]],
      password: [null, [Validators.required]],
      rememberMe: true
    });

    // reset login status
    // this.authenticationService.logout();
    // get return url from route parameters or default to '/'
    // tslint:disable-next-line: no-string-literal
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  carouselOption: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    nav: false,
    dots: true,
    responsive: {
      680: {
        items: 1
      },
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  /**
   * Form submit
   */
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.submitted = false;
      return;
    } else {
      this._LoginService.Login(this.loginForm.value).subscribe({
        next: (res: LoginRes) => {
          this.messageError = '';
          this.submitted = false;
          localStorage.setItem('user_ERP', JSON.stringify(res.data))
          // if (res.data.roleNames.includes('Superadmin')) {
            // this.router.navigateByUrl(`/company-details`);
            this.router.navigateByUrl(`/companies/projects`);
            // this.getUserCompanies()
          // } else {
          //   this.router.navigateByUrl(`/companies/${res.data.company_Id}`);
          //   this._SharedService.companyID.next(res.data.company_Id);
          // }
          this.authenticationService.isAuth.next(true);
          this.toastrService.success(res.message ? res.message : 'تم تسجيل الدخول بنجاح');
        }, error: (err: Error) => {
          this.submitted = false;
          this.messageError = err.message
        },
      })
    }
  }

//   getUserCompanies(){
//     this.ServicesService.getUserCompanies().subscribe({
//       next: (res: any) => {
//         this._SharedService.allUserCompanies.next(res.data);
//         console.log(this._SharedService.allUserCompanies)
//       }
//   })
// }
}
